import { render, staticRenderFns } from "./ItemProductModal.vue?vue&type=template&id=3cf548d0&scoped=true"
import script from "./ItemProductModal.vue?vue&type=script&lang=js"
export * from "./ItemProductModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf548d0",
  null
  
)

export default component.exports